import apiClient from "../../../../../../services/apiClient";



export const childrenStatisticsActions = {
  // Получение годов и районов для детских садов
  getKindergartenGroupsYears: async() => {
    const url = 'kindergartens/getKGGroupsYears';
    return await apiClient.get(url);
  },

  // Получение общей статистики по детям
  getChildrenGeneralStatistics: async(data) => {
    const url = 'statistics_childrens_general';
    return await apiClient.post(url, data);
  },

   // Получение информации о детях
  getInfoAboutChildrens: async (params) => {
    const url = params ? `getInfoAboutChildrens?${params}` : 'getInfoAboutChildrens';
    return await apiClient.get(url);
  },

  // Получение информации о нескольких детях
  getChildrenMany: async (childrenIds) => {
    const linkGet = 'getChildrenMany';
    const fields = {
      'birthCertificate': 1,
      'birthDate': 1,
      'firstName': 1,
      'lastName': 1
    };
    return await apiClient.post(linkGet, { 'obj': childrenIds, 'fields': fields });
  }



};
